import React, { FC, useRef, useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useMount } from "react-use";
import { Icon } from "../../../components";

type Props = {
  message: string;
};
const ErrorIcon: FC<Props> = ({ message }) => {
  // Initially show overlay and don't remove it when clicked
  const [show, setShow] = useState(true);
  const errorRef = useRef(null);

  useMount(() => {
    (errorRef.current as unknown as HTMLDivElement)?.click();
  });

  return (
    <OverlayTrigger
      defaultShow
      show={show}
      onToggle={() => setShow(true)}
      overlay={
        <Tooltip style={{ zIndex: 1100 }} id="global-search-error-tooltip">
          {message}
        </Tooltip>
      }
      placement="bottom"
      trigger="click"
    >
      <div ref={errorRef} id="global_search_error_icon">
        <Icon name="error" />
      </div>
    </OverlayTrigger>
  );
};

export default ErrorIcon;
